module.exports = __webpack_public_path__ + "static/media/add-to-home.9cca80a3.svg";